var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-304 -238) translate(304 238)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    d: "M17.633 5.5h-1.3V4.2h-.867v1.3H8.533V4.2h-.867v1.3h-1.3C5.173 5.5 4.2 6.472 4.2 7.667v9.967c0 1.195.972 2.167 2.167 2.167h11.266c1.195 0 2.167-.972 2.167-2.167V7.667c0-1.195-.973-2.167-2.167-2.167zm.97 11.918c0 .653-.556 1.184-1.238 1.184H6.635c-.683 0-1.238-.531-1.238-1.184v-7.11h13.205v7.11zm0-8.307H5.396V7.873c0-.683.555-1.239 1.238-1.239h1.239v.826h.824v-.825h6.603v.826h.825v-.826h1.239c.682 0 1.237.555 1.237 1.238V9.11z",
    transform: "translate(-304 -238) translate(304 238)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic-calendar.7dcd5b03.svg";
export { ForwardRef as ReactComponent };